import type { PivotChartSpecPipeline, VChartSpecPipeline } from 'src/types'
import {
  animationMorph,
  initColumn,
  columnAnimation,
  datasetXY,
  xBand,
  yLinear,
  backgroundColor,
  label,
  tooltip,
  discreteLegend,
  color,
  pivotAdapter,
  initPivot,
  datasetPivot,
  pivotIndicators,
  pivotDiscreteLegend,
  pivotIndicatorsAsRow,
  pivotGridStyle,
  pivotRowDimensions,
  pivotColumnDimensions,
  stackInverse,
  columnStyle,
  annotationPoint,
  annotationVerticalLine,
  annotationHorizontalLine,
  annotationDifferenceLine,
  annotationAreaBand,
  verticalCrosshairRect,
  barCornerRadius,
  progressive,
  colorAdapter,
  linearColor,
  colorLegend,
  colorBarStyleFill,
  pivotColorLegend,
  barMaxWidth,
  columnPolynomialRegressionLine,
  pivotAxisStyle,
  pivotTitle,
  dimensionLinkage,
  brush,
  fontFamilyTheme,
  regionPadding,
} from '../pipes'

const column: VChartSpecPipeline = [
  fontFamilyTheme,
  initColumn,
  columnAnimation,
  regionPadding,
  barCornerRadius,
  barMaxWidth,
  stackInverse,
  colorAdapter(color, linearColor),
  backgroundColor,
  datasetXY,
  animationMorph,
  progressive,
  xBand,
  yLinear,
  label,
  brush,
  tooltip({ titleEncoding: 'x' }),
  verticalCrosshairRect,
  colorAdapter(discreteLegend, colorLegend),
  colorBarStyleFill(columnStyle),
  annotationPoint,
  annotationVerticalLine,
  annotationHorizontalLine,
  annotationDifferenceLine,
  annotationAreaBand,
  columnPolynomialRegressionLine,
]

const pivotColumn: PivotChartSpecPipeline = [
  initPivot,
  pivotGridStyle,
  pivotIndicatorsAsRow,
  datasetPivot,
  pivotIndicators([
    fontFamilyTheme,
    initColumn,
    columnAnimation,
    regionPadding,
    barCornerRadius,
    barMaxWidth,
    stackInverse,
    colorAdapter(color, linearColor),
    backgroundColor,
    datasetXY,
    animationMorph,
    progressive,
    xBand,
    pivotAxisStyle(yLinear),
    brush,
    label,
    tooltip({ titleEncoding: 'x' }),
    verticalCrosshairRect,
    colorBarStyleFill(columnStyle),
    annotationPoint,
    annotationVerticalLine,
    annotationHorizontalLine,
    annotationDifferenceLine,
    annotationAreaBand,
    columnPolynomialRegressionLine,
  ]),
  pivotRowDimensions,
  pivotColumnDimensions,
  pivotTitle,
  colorAdapter(pivotDiscreteLegend, pivotColorLegend),
  dimensionLinkage,
]

export const columnSpecPipeline = [pivotAdapter(column, pivotColumn)]
